import React from "react";
import "./CallForPapersSidebar.css";
import { useNavigate } from "react-router-dom";

export default function CallForPapersSidebar() {
  const navigate = useNavigate();
  return (
    <aside className="cfp-sidebar">
      <div className="cfp-box cfp-call">
        <p className="cfp-call-header">Call for Papers - Oct, 2025</p>
        <p className="cfp-issue">Vol 09 Issue 10 Oct - 2025</p>
      </div>

      <div className="cfp-deadline-box">
        <h4 className="cfp-deadline-title">Submission Deadline</h4>
        <p className="cfp-deadline-date">31st October, 2025</p>
        <p className="cfp-status">Status Notification - 01 day</p>
        <p className="cfp-publication">Final Publication - 01 day</p>
        <button
          className="cfp-submit-btn"
          onClick={() => navigate("/OnlineSubmission")}
        >
          <span className="cfp-submit-btn-text">Submit Paper Here</span>
        </button>
      </div>

      <div className="cfp-links">
        <a href="#" className="cfp-link cfp-link-blue">
          SUBMIT RESEARCH PAPER
        </a>
        <a href="#" className="cfp-link cfp-link-green">
          SUBMIT PAYMENT PROOF
        </a>
        <a href="#" className="cfp-link-google">
          Find us on Google Scholar
        </a>
      </div>

      <div className="cfp-citation-section">
        <h4 className="cfp-citation-title">[ Citations Report ]</h4>
        <div className="cfp-citation-stats">
          <div className="cfp-citation-item">
            <span>Citations</span> <span>18650</span>
          </div>
          <div className="cfp-citation-item">
            <span>h-index</span> <span>50</span>
          </div>
          <div className="cfp-citation-item">
            <span>i10-index</span> <span>469</span>
          </div>
        </div>

        <div className="cfp-bar-chart">
          <div className="cfp-bar" style={{ height: "20%" }}></div>
          <div className="cfp-bar" style={{ height: "35%" }}></div>
          <div className="cfp-bar" style={{ height: "50%" }}></div>
          <div className="cfp-bar" style={{ height: "70%" }}></div>
          <div className="cfp-bar" style={{ height: "100%" }}></div>
          <div className="cfp-bar" style={{ height: "80%" }}></div>
        </div>
      </div>
    </aside>
  );
}
